import createContainer from 'constate';
import React, { useEffect, useState } from 'react';
import constants from '../config/constants';
import { usePdpTags } from '../external_dependencies/analytic/tags/pdp';

function useDigitalDataContextHook() {
  const [page, setPage] = useState('');
  const [shouldUpdateDigitalData, setShouldUpdateDigitalData] = useState(false);
  const pdpTags = usePdpTags();

  function init() {
    if (!window.digitalData) {
      window.digitalData = {};
    }
    if (!window.digitalData.tag) {
      Object.assign(window.digitalData, { tag: {} });
    }
    setShouldUpdateDigitalData(true);
  }

  const digitalData = {
    pdp: pdpTags,
    setPage,
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (shouldUpdateDigitalData && page === constants.PAGES.PDP && pdpTags.updateCounter > 0) {
      pdpTags.addTags();
    }
  }, [page, shouldUpdateDigitalData, pdpTags.updateCounter]);

  return { digitalData };
}

const [DigitalDataProvider, useDigitalDataContext] = createContainer(useDigitalDataContextHook);

const withDigitalData = (WrappedComponent) => {
  const { getInitialProps } = WrappedComponent;
  const ComponentWithDigitalData = (props) => {
    const digitalData = useDigitalDataContext();
    return <WrappedComponent {...props} {...digitalData} />;
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithDigitalData.getInitialProps = getInitialProps;
  }
  return ComponentWithDigitalData;
};

export { DigitalDataProvider, useDigitalDataContext, withDigitalData };
